const Gallery = () => {
  return (
    <div className="center-greetings">
      <h1>갤러리</h1>
      <hr></hr>
      <div style={{ display: "flex" }}>
        <div className="gallery-img">
          <img
            alt="product"
            style={{ width: "100%" }}
            src="/img/product1.jpg"
          ></img>
        </div>
        <div className="gallery-img">
          <img
            alt="product"
            style={{ width: "100%" }}
            src="/img/product2.jpg"
          ></img>
        </div>
      </div>

      <div style={{ display: "flex" }}>
        <div className="gallery-img">
          <img
            alt="product"
            style={{ width: "100%" }}
            src="/img/gallery3.jpg"
          ></img>
        </div>
        <div className="gallery-img">
          <img
            alt="product"
            style={{ width: "100%" }}
            src="/img/product4.jpg"
          ></img>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
